import { collectionSetupAxiosInstance } from '../../axios/collectionSetupAxios';

export const getTaxService = async () => {
  const result = await collectionSetupAxiosInstance.get<any>(`/redCash/api/v1.0/tax`);

  return result;
};
